import blogPost from '../../assets/partners/vardan-papikyan-JzE1dHEaAew-unsplash.jpg'
import {
  createStyles,
  Group,
  Title,
  Text,
  Card,
  Container,
  rem,
  Image,
  Box,
  SimpleGrid,
} from '@mantine/core';
import { postsEn, postsNL } from '../../languages/blogPages';
import { Newsletter } from '../informative/Newsletter';
import Image1 from '../../assets/partners/Image.png'
import Image2 from '../../assets/partners/Image (1).png'
import Image3 from '../../assets/partners/Image (2).png'

const useStyles = createStyles((theme) => ({
  title: {
    [theme.fn.smallerThan('sm')]: {
      fontSize: rem(24),
    },
  },

  description: {
    maxWidth: 600,
    margin: 'auto',
    fontWeight: 200,
  },

  card: {
    transition: 'transform 150ms ease, box-shadow 150ms ease',

    '&:hover': {
      transform: 'scale(1.01)',
      boxShadow: theme.shadows.md,
    },
  },
}));

export default function Partners() {
  const { classes } = useStyles();
  const languagePrefix = window.location.pathname.startsWith('/nl') ? '/nl' : window.location.pathname.startsWith('/de') ? '/de' : '/';

  const content = {
    '/': {
      'groupTitle': 'OUR PARTNERS',
      'mainTitle': 'Collaborative Hospitality: Empowering Partnerships for Sustainable Tourism',
      'description': "At ResiRent, we believe in the power of collaboration. We work closely with local tourism offices, small businesses, and passionate hosts to build a sustainable and supportive ecosystem for the short-term rental industry.",
      'description2': "We gather insights from tourism offices to meet regional travel needs. Language support is key for serving international tourists. Local guides help us understand tourism challenges firsthand. We collaborate to promote eco-friendly, sustainable tourism. These insights drive smart solutions for small accommodation hosts.",
      'description3': "Supporting local sustainable businesses is central to our mission. We partner with eco-conscious brands like Kewlox and More Circular. Anja leads collaborations in Belgium and Austria. More Circular uses urban mining to recycle construction waste. These efforts reduce landfill use and boost green innovation.",
      'description4': "We build strong partnerships with small hosts from diverse backgrounds. Theresia, a former pension manager near Schladming, Austria, is one example. She now runs a cozy mountain apartment, welcoming family and guests alike. Her hospitality experience offers deep insights into host needs. These insights help us tailor solutions for small and family-run rentals. Supporting experienced local hosts is key to our hosting platform’s success.",
      'legalTitle': 'Legal & Compliance Experts',
      'legalDescription': 'Short-term rental laws can be complex. Our partnerships with legal consultants, insurance companies, and compliance platforms help hosts navigate regulations, stay protected, and avoid legal pitfalls.',
      'visitWebsite': 'Visit The Website',
      'techTitle': 'Tech & Software Partners',
      'techDesc': 'Technology simplifies hosting. We integrate with smart home device providers, booking software solutions, and automation tools that enhance security, streamline operations, and improve the guest experience.',
      'marketingTitle': 'Marketing & Branding Agencies',
      'marketingDesc': 'A strong brand attracts more bookings. We collaborate with digital marketing experts, website designers, and branding specialists to help hosts create compelling listings, professional websites, and effective advertising strategies.',
    },
    '/nl': {
      'groupTitle': 'ONZE PARTNERS',
      'mainTitle': 'Samenwerkende Gastvrijheid: Partnerschappen voor Duurzaam Toerisme Versterken',
      'description': "Bij ResiRent geloven we in de kracht van samenwerking. We werken nauw samen met lokale toeristenbureaus, kleine bedrijven en gepassioneerde verhuurders om een duurzaam en ondersteunend ecosysteem te bouwen voor de kortetermijnverhuursector.",
      'description2': "We verzamelen inzichten van toeristenbureaus om aan regionale reisbehoeften te voldoen. Taalondersteuning is essentieel voor het bedienen van internationale toeristen. Lokale gidsen helpen ons om toeristische uitdagingen uit de eerste hand te begrijpen. We werken samen om milieuvriendelijk, duurzaam toerisme te bevorderen. Deze inzichten stimuleren slimme oplossingen voor kleine accommodatieverhuurders.",
      'description3': "Het ondersteunen van lokale duurzame bedrijven staat centraal in onze missie. We werken samen met milieubewuste merken zoals Kewlox en More Circular. Anja leidt samenwerkingen in België en Oostenrijk. More Circular gebruikt 'urban mining' om bouwafval te recyclen. Deze inspanningen verminderen het gebruik van stortplaatsen en stimuleren groene innovatie.",
      'description4': "We bouwen sterke partnerschappen op met kleine verhuurders met diverse achtergronden. Theresia, een voormalig pensionmanager in de buurt van Schladming, Oostenrijk, is daar een voorbeeld van. Ze runt nu een gezellig bergappartement, waar ze zowel familie als gasten verwelkomt. Haar ervaring in de horeca biedt diepgaande inzichten in de behoeften van verhuurders. Deze inzichten helpen ons om oplossingen op maat te maken voor kleine en familiegerunde verhuuraccommodaties. Het ondersteunen van ervaren lokale verhuurders is essentieel voor het succes van ons verhuurplatform.",
      'legalTitle': 'Juridische & Compliance-experts',
      'legalDescription': 'Wetten voor kortetermijnverhuur kunnen complex zijn. Onze samenwerkingen met juridische adviseurs, verzekeringsmaatschappijen en complianceplatforms helpen verhuurders om regelgeving te begrijpen, zich te beschermen en juridische valkuilen te vermijden.',
      'visitWebsite': 'Bezoek de Website',
      'techTitle': 'Tech- & Softwarepartners',
      'techDesc': 'Technologie vereenvoudigt verhuren. We integreren met aanbieders van slimme apparaten, boekingssoftware en automatiseringstools die de veiligheid verhogen, processen stroomlijnen en de gastbeleving verbeteren.',
      'marketingTitle': 'Marketing- & Brandingbureaus',
      'marketingDesc': 'Een sterk merk zorgt voor meer boekingen. We werken samen met digitale marketingexperts, webdesigners en merkstrategen om hosts te helpen aantrekkelijke advertenties, professionele websites en effectieve marketingstrategieën te creëren.',
    },
    '/de': {
      'groupTitle': 'UNSERE PARTNER',
      'mainTitle': 'Gemeinsame Gastfreundschaft: Partnerschaften für Nachhaltigen Tourismus Stärken',
      'description': "Bei ResiRent glauben wir an die Kraft der Zusammenarbeit. Wir arbeiten eng mit lokalen Tourismusbüros, kleinen Unternehmen und leidenschaftlichen Gastgebern zusammen, um ein nachhaltiges und unterstützendes Ökosystem für die Kurzzeitvermietungsbranche aufzubauen.",
      'description2': "Wir sammeln Erkenntnisse von Tourismusbüros, um regionale Reisebedürfnisse zu erfüllen. Sprachliche Unterstützung ist entscheidend, um internationale Touristen zu bedienen. Lokale Reiseführer helfen uns, touristische Herausforderungen aus erster Hand zu verstehen. Wir arbeiten zusammen, um umweltfreundlichen, nachhaltigen Tourismus zu fördern. Diese Erkenntnisse treiben intelligente Lösungen für kleine Unterkunftsvermieter voran.",
      'description3': "Die Unterstützung lokaler nachhaltiger Unternehmen ist zentral für unsere Mission. Wir arbeiten mit umweltbewussten Marken wie Kewlox und More Circular zusammen. Anja leitet Kooperationen in Belgien und Österreich. More Circular nutzt Urban Mining, um Bauabfälle zu recyceln. Diese Bemühungen reduzieren die Nutzung von Mülldeponien und fördern grüne Innovationen.",
      'description4': "Wir bauen starke Partnerschaften mit kleinen Gastgebern unterschiedlicher Herkunft auf. Theresia, eine ehemalige Pensionsmanagerin in der Nähe von Schladming, Österreich, ist ein Beispiel dafür. Sie betreibt jetzt ein gemütliches Bergapartment und empfängt sowohl Familie als auch Gäste. Ihre Erfahrung im Gastgewerbe bietet tiefe Einblicke in die Bedürfnisse von Gastgebern. Diese Erkenntnisse helfen uns, maßgeschneiderte Lösungen für kleine und familiengeführte Mietunterkünfte zu entwickeln. Die Unterstützung erfahrener lokaler Gastgeber ist entscheidend für den Erfolg unserer Gastgeberplattform.",
      'legalTitle': 'Rechts- & Compliance-Experten',
      'legalDescription': 'Gesetze zur Kurzzeitvermietung können komplex sein. Unsere Partnerschaften mit Rechtsberatern, Versicherungen und Compliance-Plattformen helfen Gastgebern, Vorschriften zu verstehen, geschützt zu bleiben und rechtliche Fallstricke zu vermeiden.',
      'visitWebsite': 'Zur Website',
      'techTitle': 'Technologie- & Softwarepartner',
      'techDesc': 'Technologie vereinfacht das Hosting. Wir integrieren uns mit Anbietern von Smart-Home-Geräten, Buchungssoftware und Automatisierungstools, die Sicherheit verbessern, Abläufe optimieren und das Gästeerlebnis steigern.',
      'marketingTitle': 'Marketing- & Branding-Agenturen',
      'marketingDesc': 'Eine starke Marke bringt mehr Buchungen. Wir arbeiten mit Experten für digitales Marketing, Webdesignern und Markenstrategen zusammen, um Gastgebern zu helfen, überzeugende Inserate, professionelle Webseiten und effektive Werbestrategien zu erstellen.',
    },
  };

  return (
    <Box>
      {/* <Image
        src={blogPost}
        alt="Landscape"
        height={400}
      ></Image> */}
      <Container size="lg" py={100}>
        <Group position="center">
          <Title order={4} weight={600} align="center" color="#003D51" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
            {content[languagePrefix].groupTitle}
          </Title>
        </Group>

        <Title order={2} className={classes.title} ta="center" mt="sm" style={{ fontFamily: 'Inter, sans-serif', fontWeight: '600', fontSize: '48px', color: '#101828' }}>
          {languagePrefix === '/nl' ? "Onze Vertrouwde Partners & Samenwerkers" : languagePrefix === '/de' ? "Unsere Vertrauenswürdigen Partner & Mitarbeiter" : "Our Trusted Partners & Collaborators"}
        </Title>

        <Text className={classes.description} ta="center" my="lg" style={{ fontFamily: 'Inter, sans-serif', fontWeight: '400', fontSize: '14px', color: '#667085' }}>
          {/* {content[languagePrefix].description} */}
          {content[languagePrefix].description}
        </Text>

        <Image
          src={blogPost}
          alt="Landscape"
          height={400}
        ></Image>

        <Text className={classes.description} ta="justify" my="lg" style={{ fontFamily: 'Inter, sans-serif', fontWeight: '400', fontSize: '18px', color: '#667085' }}>
          {/* {content[languagePrefix].description} */}
          {content[languagePrefix].description2}
        </Text>

        <Text className={classes.description} ta="justify" my="lg" style={{ fontFamily: 'inter, sans-serif', fontWeight: '400', fontSize: '18px', color: '#667085' }}>
          {/* {content[languagePrefix].description} */}
          {content[languagePrefix].description3}
        </Text>

        <Text className={classes.description} ta="justify" my="lg" style={{ fontFamily: 'inter, sans-serif', fontWeight: '400', fontsize: '18px', color: '#667085' }}>
          {/* {content[languagePrefix].description} */}
          {content[languagePrefix].description4}
        </Text>

        <SimpleGrid cols={2} spacing="xl" mt={50} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <Image
            radius="md"
            src={Image1}
            alt="Legal Books"
            style={{ width: '100%', maxWidth: 400 }}
          />

          <Box>
            <Title
              order={3}
              style={{
                fontFamily: 'Inter, sans-serif',
                color: '#101828',
                fontSize: '40px',
                fontWeight: '600',
                width: 760,
              }}
            >
              {content[languagePrefix].legalTitle}
            </Title>

            <Text
              mt="sm"
              style={{
                fontFamily: 'Inter, sans-serif',
                color: '#667085',
                fontSize: '17px',
                fontWeight: '400',
                width: 760,
                height: 80,
              }}
            >
              {content[languagePrefix].legalDescription}
            </Text>

            <Box mt="lg">
              <a href="https://your-legal-partners-website.com" target="_blank" rel="noopener noreferrer">
                <Box
                  component="button"
                  style={{
                    backgroundColor: '#003D51',
                    color: '#fff',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: 'pointer',
                  }}
                >
                  {content[languagePrefix].visitWebsite}
                </Box>
              </a>
            </Box>
          </Box>
        </SimpleGrid>

        <SimpleGrid cols={2} spacing="xl" mt={50} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <Image
            radius="md"
            src={Image2}
            alt="Legal Books"
            style={{ width: '100%', maxWidth: 400 }}
          />

          <Box>
            <Title order={3} style={{ fontFamily: 'Inter, sans-serif', color: '#101828', fontSize: '40px', fontWeight: '600' }}>
              {content[languagePrefix].techTitle}
            </Title>

            <Text mt="sm" style={{ fontFamily: 'Inter, sans-serif', color: '#667085', fontSize: '17px', fontWeight: '400', maxWidth: 760 }}>
              {content[languagePrefix].techDesc}
            </Text>

            <Box mt="lg">
              <a href="https://spartacapitalgroup.com/" target="_blank" rel="noopener noreferrer">
                <Box
                  component="button"
                  style={{
                    backgroundColor: '#003D51',
                    color: '#fff',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: 'pointer',
                  }}
                >
                  {content[languagePrefix].visitWebsite}
                </Box>
              </a>
            </Box>
          </Box>
        </SimpleGrid>

        <SimpleGrid cols={2} spacing="xl" mt={50} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <Image
            radius="md"
            src={Image3}
            alt="Legal Books"
            style={{ width: '100%', maxWidth: 400 }}
          />

          <Box>
            <Title order={3} style={{ fontFamily: 'Inter, sans-serif', color: '#101828', fontSize: '35px', fontWeight: '600' }}>
              {content[languagePrefix].marketingTitle}
            </Title>

            <Text mt="sm" style={{ fontFamily: 'Inter, sans-serif', color: '#667085', fontSize: '17px', fontWeight: '400', maxWidth: 760 }}>
              {content[languagePrefix].marketingDesc}
            </Text>

            <Box mt="lg">
              <a href="https://your-legal-partners-website.com" target="_blank" rel="noopener noreferrer">
                <Box
                  component="button"
                  style={{
                    backgroundColor: '#003D51',
                    color: '#fff',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    border: 'none',
                    fontSize: '16px',
                    cursor: 'pointer',
                  }}
                >
                  {content[languagePrefix].visitWebsite}
                </Box>
              </a>
            </Box>
          </Box>
        </SimpleGrid>
        {/* <br></br> */}

        {/* <Newsletter /> */}
      </Container>

      <Newsletter />

    </Box >
  );
}
